module.exports = __webpack_public_path__ + "static/media/sub-modal-3.40c3779c.jpg";